import React from 'react';
import styled from 'styled-components';
import { Table as BaseTable, body, FlexColumn } from '@ubeya/shared-web/components';
import media from '@ubeya/shared-web/style/media';

const Wrapper = styled(FlexColumn).attrs(() => ({ className: 'small-table-wrapper' }))`
  width: 100%;
  margin-bottom: 16px;
  ${media.mobile`width: 50%`}
`;

const Table = styled(BaseTable).attrs((props) => ({
  headless: props.headless,
  shadow: false
}))`
  border-radius: 3px;

  .row:first-child {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }

  .row:last-child {
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
  }

  .row > div:first-child {
    padding-left: 20px;
  }

  .row > div:last-child {
    padding-right: 20px;
  }

  .cell {
    padding-left: 5px;
    padding-right: 5px;
    ${body};
  }
`;

const SmallTable = (props) => (
  <Wrapper>
    <Table {...props} headless={props?.headless === undefined ? true : props?.headless} />
  </Wrapper>
);

export default SmallTable;
